import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=8391ed58&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=8391ed58&scoped=true&lang=css"
import style1 from "./TaskList.vue?vue&type=style&index=1&id=8391ed58&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8391ed58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8391ed58')) {
      api.createRecord('8391ed58', component.options)
    } else {
      api.reload('8391ed58', component.options)
    }
    module.hot.accept("./TaskList.vue?vue&type=template&id=8391ed58&scoped=true", function () {
      api.rerender('8391ed58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/TaskList.vue"
export default component.exports